import { useEffect, useRef } from 'react';
import {
  bootEnhancedWebChat,
  launchChat,
  sendTextMessage,
} from '../../core/chat-service/infrastructure/embedded-chat-widget/chat-widget-bootstrapper';
import { useFalconContext } from '../context/cms-context/FalconContext';
import safeWindow from '../utils/safeWindows';

type UseEnhancedChatOptions = {
  visiblePrechat?: Record<string, { value: string; isEditableByEndUser?: boolean }>;
};

export function useEnhancedChatWidget({ visiblePrechat }: UseEnhancedChatOptions = {}) {
  const { cmsContent } = useFalconContext();
  const isBooted = useRef(false);

  const handleHiddenPrechat = () => {
    const currentUrl = safeWindow?.location.href;
    return { url: currentUrl };
  };

  useEffect(() => {
    if (isBooted.current) return;
    isBooted.current = true;

    return bootEnhancedWebChat(
      handleHiddenPrechat(),
      visiblePrechat,
      cmsContent.chatWidget.allowedUrls,
      cmsContent.chatWidget.excludedUrls,
      cmsContent.chatWidget.widgetButtonPosition,
      cmsContent.chatWidget.restrictSessionOnMessagingChannel,
      cmsContent.chatWidget.shouldMinimizeWindowOnNewTab,
      cmsContent.chatWidget.bootDelaySeconds ?? 0,
    );
  }, [visiblePrechat]);

  return {
    launchChat,
    sendTextMessage,
  };
}
